module.exports = __webpack_public_path__ + "9527df4d5ba19505ce4cfa03e49de127.png";